import React from 'react';
import { useAppContext } from 'src/components/app-context';
import type { HeaderBlockSlice } from '../../../../types';
import * as S from './styles';

type Props = { noMargins?: boolean; noUppercase?: boolean } & Pick<
  HeaderBlockSlice,
  'title' | 'pagination'
>;

const HeaderBlock = ({
  title,
  pagination,
  noMargins = false,
  noUppercase = false,
}: Props) => {
  const { t } = useAppContext();
  const titleWithPagination =
    pagination && pagination.currentPage > 1
      ? t('category', 'product-collection.paginated-title', {
          ...pagination,
          title,
        })
      : title;
  return (
    <S.Header $noMargins={noMargins} data-test="HeaderText">
      <S.Title noUppercase={noUppercase} $noMargins={noMargins}>
        {titleWithPagination}
      </S.Title>
    </S.Header>
  );
};

export default HeaderBlock;
